import moment from 'moment';
import 'moment/locale/th';

class DroneLayer {

    constructor() {
        this.uid = '';

        // Raw data
        this.name = '';
        this.mapServiceUrl = '';
        this.tmsUrl = ''
        this.createdAt = null;
        this.updatedAt = null;
        this.savedUid = null;
        this.isPublic = true;
        
        // Relational data
        this.userUid = null
        this.userName = ''
        this.rbac = null 

        // Object data
        this.bbox = null;
    }

    static initByUid(uid) {
        const droneLayer = new DroneLayer();
        droneLayer.uid = uid;
        return droneLayer
    }

    static initBySnapshot(docSnapshot) {
        const obj = docSnapshot.data();
        const droneLayer = new DroneLayer();

        droneLayer.uid = docSnapshot.id;
        droneLayer.name = ( obj.name !== undefined ) ? obj.name : '';
        droneLayer.savedUid = (obj.saved_uid !== undefined) ? obj.saved_uid : null;
        droneLayer.mapServiceUrl = ( obj.map_service_url !== undefined ) ? obj.map_service_url : '';
        droneLayer.tmsUrl = ( obj.tms_url !== undefined ) ? obj.tms_url : ''
        droneLayer.createdAt = ( obj.created_date !== undefined ) ? obj.created_date.toDate() : null;
        droneLayer.updatedAt = ( obj.updated_date !== undefined ) ? obj.updated_date.toDate() : null;
        droneLayer.userUid = ( obj.uid !== undefined ) ? obj.uid : '';

        if ( obj.bbox !== undefined ) {
            droneLayer.bbox = {
                northEast: {
                    lat: obj.bbox.north_east._lat,
                    lng: obj.bbox.north_east._long
                },
                southWest: {
                    lat: obj.bbox.south_west._lat,
                    lng: obj.bbox.south_west._long
                }
            };
        }
        
        if ( obj.is_public !== undefined ){
            droneLayer.isPublic = obj.is_public
            if ( obj.rbac !== undefined )
            droneLayer.rbac = obj.rbac
        }

        return droneLayer;
    }

    setUserOwnerName(username){
        this.userName = username
        return this
    }

    setRole(uid,role){
        this.rbac[uid] = role
        return this
    }

    setPublic(bool){
        this.isPublic = bool
        return this
    }

    removeUser(uid){
        delete this.rbac[uid]
        return this
    }

    bounds() {
        if ( window.google === undefined ) return null;
        var bounds = null;
        if ( this.bbox !== null ) {
            bounds = new window.google.maps.LatLngBounds(this.bbox.southWest, this.bbox.northEast);
        }
        return bounds;
    }

    createdAtString() {
        if ( this.createdAt === null ) return null;
        return moment(this.createdAt).locale('th').format('D MMMM YYYY');
    }

}

export default DroneLayer


// WEBPACK FOOTER //
// ./src/Models/DroneLayer.js